module.exports = __webpack_public_path__ + "static/media/2.cec24e47.jpg";